<template>
  <div style="padding: 2rem;">
    <div style="padding-left: 20px;">
      <p class="title is-5" style="margin-left: -20px;">Info</p>

      <table class="table is-fullwidth">
        <tr>
          <td style="width: 220px;">Name</td>
          <td>{{ publisher.name }}</td>
        </tr>

        <tr>
          <td>Type</td>
          <td>{{ publisher.type }}</td>
        </tr>
      </table>
    </div>

    <div v-if="publisher.can_publish" style="padding-left: 20px;">
      <p class="title is-5" style="margin-left: -20px;">Contact</p>

      <table class="table is-fullwidth">
        <tr>
          <td style="width: 220px;">Phone</td>
          <td>{{ publisher.phone }}</td>
        </tr>

        <tr>
          <td>Email</td>
          <td>{{ publisher.email }}</td>
        </tr>

        <tr>
          <td>Address</td>
          <td>{{ publisher.address }}</td>
        </tr>

        <tr>
          <td>Comment</td>
          <td>{{ publisher.comment }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["publisher"],

  data() {
    return {};
  },

  methods: {}
};
</script>
